import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { User } from '../../../../../../core/auth';
import { AppState } from '../../../../../../core/reducers';
import {
  FileUploadProgress,
  UploadFailure,
  UploadSuccess,
  UserfileActionTypes,
  UserfileCreate,
} from '../../../../../../core/rex';

@Component({
  selector: 'kt-usr-files',
  templateUrl: './usr-files.component.html',
  styleUrls: ['./usr-files.component.scss'],
})
export class UsrFilesComponent implements OnInit, OnDestroy {
  @Input() user: User;
  files: File[] = [];
  dragFiles: any;
  validComboDrag: any;
  invalidComboDrag: any;
  lastInvalids: any;
  progress: { [key: string]: BehaviorSubject<number> } = {};
  failed: Array<string> = [];
  fbs: BehaviorSubject<Array<string>> = new BehaviorSubject<Array<string>>(
    this.failed
  );

  private subscriptions: Subscription[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fileFB: UntypedFormBuilder,
    private store: Store<AppState>,
    private actions$: Actions,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const up = this.actions$
      .pipe(
        ofType<FileUploadProgress>(UserfileActionTypes.FileUploadProgress),
        tap(({ payload }) => {
          this.progress[payload.userfile.name].next(payload.progress);
        })
      )
      .subscribe();
    this.subscriptions.push(up);

    const us = this.actions$
      .pipe(
        ofType<UploadSuccess>(UserfileActionTypes.UploadSuccess),
        tap(({ payload }) => {
          delete this.progress[payload.userfile.name];
          this.files = this.files.filter(
            f =>
              !(
                f.name === payload.userfile.name &&
                f.size === payload.userfile.size
              )
          );
          this.ref.detectChanges();
        })
      )
      .subscribe();
    this.subscriptions.push(us);

    const uf = this.actions$
      .pipe(
        ofType<UploadFailure>(UserfileActionTypes.UploadFailure),
        tap(({ payload }) => {
          delete this.progress[payload.userfile.name];
          this.failed.push(payload.userfile.name);
          console.log(this.failed);
          this.fbs.next(this.failed);
        })
      )
      .subscribe();
    this.subscriptions.push(uf);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  uploadAll() {
    this.failed.splice(0, this.failed.length);
    this.fbs.next(this.failed);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.files.forEach((f, index) => {
      this.progress[f.name] = new BehaviorSubject<number>(0);
      this.store.dispatch(
        new UserfileCreate({ userfile: f, uid: this.user.id })
      );
    });
  }

  remove(i: number) {
    this.files.splice(i, 1);
  }
}
